import { useApiMutation, useApiQuery } from "../services/react-query";

// Invalidates nothing on its own: the caller has to store the token first,
// otherwise the refetched currentUser query goes out anonymously, 401s and —
// with retries off for 4xx — leaves the app signed out on /login.
export const useLogin = () =>
  useApiMutation({
    fetchOptions: {
      url: "/auth/login",
      method: "POST",
    },
    invalidateQueryKeys: [],
    hideNotification: true,
  });

export const useSendResetPasswordEmail = () =>
  useApiMutation({
    fetchOptions: {
      url: "/auth/forgot-password",
      method: "POST",
    },
    invalidateQueryKeys: [],
    hideNotification: true,
  });

export const useSendInviteMail = (userPublicId) =>
  useApiMutation({
    fetchOptions: {
      url: `/auth/invite/${userPublicId}`,
      method: "POST",
    },
    invalidateQueryKeys: [],
    hideNotification: true,
  });

export const useGetUserByInviteToken = (token) =>
  useApiQuery({
    queryOptions: { queryKey: ["auth"] },
    fetchOptions: {
      url: `/auth/${token}`,
      method: "GET",
    },
  });

export const useSetPassword = () =>
  useApiMutation({
    fetchOptions: {
      url: "/auth/set-password",
      method: "POST",
    },
  });

export const useGetUserByForgotPasswordToken = (token) =>
  useApiQuery({
    queryOptions: { queryKey: ["auth"] },
    fetchOptions: {
      url: `/auth/forgot-password/${token}`,
      method: "GET",
    },
  });

export const useGoogleLogin = (data) =>
  useApiMutation({
    fetchOptions: {
      url: "/auth/google-sign-in",
      method: "POST",
      body: { data },
    },
  });

export const useAppleSignIn = (data) =>
  useApiMutation({
    fetchOptions: {
      url: "/auth/apple-sign-in",
      method: "POST",
      body: { data },
    },
  });

export const usePasswordlessLogin = () => {
  return useApiMutation({
    fetchOptions: {
      url: "/auth/passwordless",
      method: "POST",
    },
    hideNotification: true,
  });
};

export const useVerifyPasswordlessToken = (token) => {
  return useApiQuery({
    queryOptions: { queryKey: ["auth"], enabled: !!token },
    fetchOptions: {
      url: `/auth/passwordless/${token}`,
      method: "GET",
    },
  });
};
